import type { CanvasChatMessage } from '@/pages/canvas/canvas-types';

/** Keep saved rosters for follow-up context, but show the result beside its artifact. */
export function taskResultContent(message: CanvasChatMessage): string {
  const content = message.content || '';
  if (message.role !== 'assistant') return content;
  const choices = message.suggestionPills;
  if (choices && choices.pills.length > 4 && (/\bproduct\b/i.test(choices.question) || choices.pills.some(pill => pill.forcedTool?.arguments.productId != null))) {
    const normalize = (value: string) => value.replace(/\*\*/g, '').replace(/[’‘]/g, "'").trim().toLowerCase();
    const labels = new Set(choices.pills.map(pill => normalize(pill.label)));
    return content.split('\n').filter(line => {
      const item = line.match(/^\s*(?:[-*•]|\d+[.)])\s+(.+)$/);
      return !item || !labels.has(normalize(item[1]));
    }).join('\n').replace(/\n{3,}/g, '\n\n').trim();
  }
  const paragraph = content.split('\n\n')[0];
  if (message.angleSetCard && message.conceptsRun?.status === 'ready') {
    const legacy = /^\d+ angle concepts? planned for .+ — saved as ".+" \(it's on the brand's Ad Angles tab too\)\. Review the full sheet in the doc, then hit "Make these ads" to generate one ad per angle\.$/;
    if (legacy.test(paragraph) && message.conceptsRun.productName) {
      const count = message.angleSetCard.angleCount;
      if (typeof count === 'number') return `${count} concept${count === 1 ? '' : 's'} ready for ${message.conceptsRun.productName}.`;
    }
    if (/^\d+ concepts? ready for .+\.$/.test(paragraph) && content.startsWith(`${paragraph}\n\nSaved concepts:\n`)) return paragraph;
  }
  if (message.agentDocument && /^\d+ ad ideas? ready for .+\.$/.test(paragraph) && content.startsWith(`${paragraph}\n\nSaved ideas:\n`)) return paragraph;
  return content;
}
